@if (SpeechRecognitionService.VoiceRecognitionAvailable()) {
<button type="button" class="ev-plain-button ev-icon" id="voice-icon" data-testid="voice-input-toggle-btn" data-tutorial-target="voice-input"
  [ngClass]="{ 'active': IsActive() }"
  (click)="ToggleSpeechRecognition()">
  <span class="ev-icon-circle">
    <img alt="Voice Input" [src]="'assets/icons/dark/ui/voice_recording_icon.svg'"
      class="icon" />
  </span>
</button>
}